import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { login } from '../../service/AuthService';
import { Card, Row, Col } from 'react-bootstrap';
import { NavLink } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setUser } from '../../store/userSlice';
import './login.css'; // Import the CSS file

function LoginForm() {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const onSubmit = data => {
        setMessage('');
        setLoading(true);

        login(data.username, data.password, dispatch, setUser)
            .then(() => {
                setLoading(false);
                window.location.href = '/profile';
            })
            .catch(error => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                setLoading(false);
                setMessage("Eroare la autentificare: " + resMessage);
            });

    };

    return (
        <Card className="login-card">
            <Card.Header className="login-card-header">
                Autentificare
            </Card.Header>
            <Card.Body>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group mb-3">
                        <label htmlFor="username" className="login-label">
                            Adresa de email
                        </label>
                        <input
                            type="text"
                            className="form-control login-input"
                            name="username"
                            {...register('username', { required: 'Vă rugăm introduceți o valoare!' })}
                        />
                        {errors.username && (
                            <div className="alert alert-danger mt-2" role="alert">
                                {errors.username.message}
                            </div>
                        )}
                    </div>

                    <div className="form-group mb-3">
                        <label htmlFor="password" className="login-label">
                            Parola
                        </label>
                        <input
                            type="password"
                            className="form-control login-input"
                            name="password"
                            {...register('password', { required: 'Vă rugăm introduceți o valoare!' })}
                        />
                        {errors.password && (
                            <div className="alert alert-danger mt-2" role="alert">
                                {errors.password.message}
                            </div>
                        )}
                    </div>

                    <Row className="d-flex justify-content-between align-items-center mt-4">
                        <Col xs="auto">
                            <button
                                className="btn btn-primary login-button"
                                disabled={loading}
                            >
                                {loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <span>Conectați-vă</span>
                                )}
                            </button>
                        </Col>
                        <Col xs="auto">
                            <NavLink className="login-forgot-password" to="/recuperare-parola">
                                Recuperare parolă
                            </NavLink>
                        </Col>
                    </Row>

                    {message && (
                        <div className="form-group mt-3">
                            <div className="alert alert-danger" role="alert">
                                {message}
                            </div>
                        </div>
                    )}
                </form>
            </Card.Body>
        </Card>
    );
}

export default LoginForm;
